import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { Episode, hasItems, Item, YouToube, Audio } from './Model';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useState } from 'react';
import { YouTubeListItem } from './YouTubeListItem';
import { EpisodeListItem } from './EpisodeListItem';
import { AudioListItem } from './AudioListItem';

export function MediaListItem(props: { item: Item }) {
    const [itemSelected, setItemSelected] = useState<boolean>(false);

    const getComponent = (item: Item) => {
        switch (item.type) {
            case 'youtube': 
                return <YouTubeListItem item={item as YouToube}/>
            case 'audio':
                return <AudioListItem item={item as Audio} />
            default:
                return <EpisodeListItem item={item as Episode}/>
        }
    }
    const elem = getComponent(props.item);
    const arrow = hasItems(props.item) ? 
    <Box sx={{ display: itemSelected ? 'flex' : 'none', alignItems: 'center', pl: 1, pb: 1, alignContent: 'flex-end' }}>
        <ArrowForwardIosIcon/>
    </Box>
    : <></>

    return (
        <Card sx={{ display: 'flex', flex: 'auto' }} onMouseOver={() => setItemSelected(true)} onMouseOut={() => setItemSelected(false)}>
            {elem}
            {arrow}
        </Card>
    );
}
